module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Volume One")]), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Volume One"
    }
  }, [_c('p', {
    staticClass: "tx53"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('b', [_vm._v("104 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Use credit cards only for convenience, never for credit.")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0025-01-1"
    }
  }, [_c('b', [_vm._v("105 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Treat yourself to a massage on your birthday.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0025-01-2"
    }
  }, [_c('b', [_vm._v("106 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Never cheat.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0025-01-3"
    }
  }, [_c('b', [_vm._v("107 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Smile a lot. It costs nothing and is beyond price.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0025-01-4"
    }
  }, [_c('b', [_vm._v("108 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Know how to drive a stick shift.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0025-01-5"
    }
  }, [_c('b', [_vm._v("109 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Spread crunchy peanut butter on Pepperidge Farm Gingerman cookies for the perfect late-night snack.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0025-01-6"
    }
  }, [_c('b', [_vm._v("110 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Never use profanity.")])])]), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0026-P-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('b', [_vm._v("111 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  })]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("When dining with clients or business associates, never order more than one cocktail or one glass of wine. If no one else is drinking, don’t drink at all.\n ")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0026-01-1"
    }
  }, [_c('b', [_vm._v("112 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Never argue with police officers, and address them as “officer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0026-01-2"
    }
  }, [_c('b', [_vm._v("113 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Learn to identify local wildflowers, birds, and trees.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0026-01-3"
    }
  }, [_c('b', [_vm._v("114 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Keep a fire extinguisher in your kitchen and car.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0026-01-4"
    }
  }, [_c('b', [_vm._v("115 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Give yourself a year and read the Bible cover to cover.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0026-01-5"
    }
  }, [_c('b', [_vm._v("116 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Consider writing a living will.")])])]), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0027-P-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('b', [_vm._v("117 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Install dead bolt locks on outside doors.")])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0027-01-1"
    }
  }, [_c('b', [_vm._v("118 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Don’t buy expensive wine, luggage, or watches.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0027-01-2"
    }
  }, [_c('b', [_vm._v("119 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Put a lot of little marshmallows in your hot chocolate.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0027-01-3"
    }
  }, [_c('b', [_vm._v("120 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Learn CPR.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0027-01-4"
    }
  }, [_c('b', [_vm._v("121 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Resist the temptation to buy a boat. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0027-P-2"
    }
  }, [_c('b', [_vm._v("122 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Stop and read historical roadside markers.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx53",
    attrs: {
      "id": "p0027-01-5"
    }
  }, [_c('b', [_vm._v("123 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Respect your children’s privacy. Knock before entering their room.")])])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page27"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b75d6eac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter10.vue
// module id = 99
// module chunks = 0